// error.service.ts

import { ErrorPayload } from "./ErrorContext";

let errorHandler: ((error: ErrorPayload) => void) | null = null;

export const registerErrorHandler = (handler: (e: ErrorPayload) => void) => {
  errorHandler = handler;
};

export const raiseError = (error: ErrorPayload) => {
  if (!errorHandler) {
    console.warn("Error handler not registered yet", error);
    return;
  }
  errorHandler(error);
};
